import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
  createEnv({
    client: {
      NEXT_PUBLIC_BILLING_PRICE_PRO_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_TEAM_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_PLUS_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_TRIAL_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_PLUS_YEAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_TEAM_YEAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_PRO_YEAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_COUPON_PLUS: z.string().optional(),
      NEXT_PUBLIC_BILLING_COUPON_TEAM: z.string().optional(),
      NEXT_PUBLIC_BILLING_COUPON_PRO: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STARTER_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STANDARD_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_POWER_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_UPLOAD_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_VOICE_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_RENDER_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_TRANSLATION_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_STORAGE_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_AVATAR_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_ADDON_CUSTOM_AVATAR_ID: z.string().optional()
    },
    server: {
      BILLING_STRIPE_SECRET_KEY: z.string().optional(),
      BILLING_STRIPE_WEBHOOK_SECRET: z.string().optional(),
      // AppSumo lifetime licensing (packages/billing/src/appsumo). The API key
      // doubles as the webhook HMAC secret and the Licensing API header.
      APPSUMO_API_KEY: z.string().optional(),
      APPSUMO_CLIENT_ID: z.string().optional(),
      APPSUMO_CLIENT_SECRET: z.string().optional(),
      APPSUMO_REDIRECT_URI: z.string().url().or(z.literal('')).optional(),
      APPSUMO_ENABLED: z.string().optional()
    },
    runtimeEnv: {
      NEXT_PUBLIC_BILLING_PRICE_PRO_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_PRO_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_TEAM_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_TEAM_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_PLUS_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_PLUS_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_TRIAL_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_TRIAL_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_PLUS_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_PLUS_YEAR_ID,
      NEXT_PUBLIC_BILLING_PRICE_TEAM_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_TEAM_YEAR_ID,
      NEXT_PUBLIC_BILLING_PRICE_PRO_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_PRO_YEAR_ID,
      NEXT_PUBLIC_BILLING_COUPON_PLUS:
        process.env.NEXT_PUBLIC_BILLING_COUPON_PLUS,
      NEXT_PUBLIC_BILLING_COUPON_TEAM:
        process.env.NEXT_PUBLIC_BILLING_COUPON_TEAM,
      NEXT_PUBLIC_BILLING_COUPON_PRO:
        process.env.NEXT_PUBLIC_BILLING_COUPON_PRO,
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STARTER_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STARTER_ID,
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STANDARD_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_STANDARD_ID,
      NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_POWER_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDIT_PACK_POWER_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_UPLOAD_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_UPLOAD_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_VOICE_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_VOICE_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_RENDER_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_RENDER_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_TRANSLATION_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_TRANSLATION_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_STORAGE_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_STORAGE_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_AVATAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_AVATAR_ID,
      NEXT_PUBLIC_BILLING_PRICE_ADDON_CUSTOM_AVATAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_ADDON_CUSTOM_AVATAR_ID,
      BILLING_STRIPE_SECRET_KEY: process.env.BILLING_STRIPE_SECRET_KEY,
      BILLING_STRIPE_WEBHOOK_SECRET: process.env.BILLING_STRIPE_WEBHOOK_SECRET,
      APPSUMO_API_KEY: process.env.APPSUMO_API_KEY,
      APPSUMO_CLIENT_ID: process.env.APPSUMO_CLIENT_ID,
      APPSUMO_CLIENT_SECRET: process.env.APPSUMO_CLIENT_SECRET,
      APPSUMO_REDIRECT_URI: process.env.APPSUMO_REDIRECT_URI,
      APPSUMO_ENABLED: process.env.APPSUMO_ENABLED
    }
  });
